import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ptg-progress-mask',
  templateUrl: './progress-mask.component.html',
  styleUrls: ['./progress-mask.component.scss']
})
export class ProgressMaskComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
